import Vue from 'vue';
import vClickOutside from 'v-click-outside';
import VueLazyLoad from './lazy-load';


const directives = [
    {
        name: 'lazyload',
        directive: VueLazyLoad
    },
    {
        name: 'click-outside',
        directive: vClickOutside.directive
    }
];

directives.forEach(it => Vue.directive(it.name, it.directive));
